import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

const initialState = {
  userInfoGetRequestStatus: null,
  userInfoUpdateRequestStatus: null,

  userName: null,
  userTimezone: 4,
};

export const getUserInfo = createAsyncThunk(
  'settingsProfile/getUserInfo',
  async (data, { rejectWithValue }) => {
    const api = '/settings/user/get?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.user;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateUserInfo = createAsyncThunk(
  'settingsProfile/updateUserInfo',
  async (data, { rejectWithValue }) => {
    const api = '/settings/user/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const kitchenDashboardSlice = createSlice({
  name: 'settingsProfile',
  initialState,
  extraReducers: (builder) => {
    builder
      // getUserInfo
      .addCase(getUserInfo.pending, (state) => { state.userInfoGetRequestStatus = 'pending'; })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        const data = action.payload
        state.userInfoGetRequestStatus = 'resolved';
        state.userName = data?.name || null;
        state.userTimezone = data?.timezone || 4;
      })
      .addCase(getUserInfo.rejected, (state) => { state.userInfoGetRequestStatus = 'rejected'; })
      // updateUserInfo
      .addCase(updateUserInfo.pending, (state) => { state.userInfoUpdateRequestStatus = 'pending'; })
      .addCase(updateUserInfo.fulfilled, (state, action) => {
        state.userInfoUpdateRequestStatus = 'resolved';
        state.userName = action.payload.name;
        state.userTimezone = action.payload.timezone;
      })
      .addCase(updateUserInfo.rejected, (state) => { state.userInfoUpdateRequestStatus = 'rejected'; })
      //PURGE
      .addCase(PURGE, () => { return initialState; })
  },
  reducers: {},
});

export const {} = kitchenDashboardSlice.actions;

export default kitchenDashboardSlice.reducer;
